import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const icon: SxStyleFunc<boolean | undefined> = (disabled) => ({
  color: disabled ? (p) => p.palette.grey[500] : (p) => p.palette.primary[500],
  opacity: disabled ? 0.5 : 1,
});

export const paper: SxStyle = {
  '& .highlight': {
    backgroundColor: 'transparent !important',
    fontWeight: '700 !important',
    color: 'inherit',
  },
};
